import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function SocialProof() {
  const reviews = [{
    quote: 'They did an amazing job at diagnosing my issue with my brakes and repairing it in a day. The master cylinder was the culprit. And it was because I brought it somewhere they did it "Cheaper" I now know that for my vehicle, it\'s more important to pay the price for quality work.',
    author: 'Robert B.'
  }, {
    quote: "Lancer was able to locate a functioning used part and diagnose coil-on-plug issues that need to be addressed... I had taken the vehicle to other repair shops who were unable to give me a solution... I've driven the vehicle for over two years now since it was repaired.",
    author: 'Stephen J.'
  }, {
    quote: 'Chad and the crew are second to none for auto service in Lowertown. I came to them with an EV problem that they had not experienced before. The commitment to purchase needed software and perform diagnostic testing to reach the root of the problem was above and beyond.',
    author: 'Robert B.'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-167">
      <div className="max-w-6xl mx-auto" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-169">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-170">
            Customer reviews
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-6" data-id="element-171">
            Trusted by St. Paul drivers for nearly 50 years
          </h2>
          <div className="flex items-center justify-center gap-3 text-xl font-bold text-brand-dark" data-id="element-172">
            <span data-id="element-173">4.9</span>
            <div className="flex text-brand-gold" data-id="element-174">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-current" data-id="element-175" />)}
            </div>
            <span className="text-gray-500 font-medium text-[14px]" data-id="element-176">
              Based on 595 Google reviews
            </span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-177">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-brand-light p-8 rounded-2xl border border-gray-200 shadow-sm flex flex-col" data-id="element-178">
              <div className="flex text-brand-gold mb-6" data-id="element-179">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-180" />)}
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-8 flex-grow italic" data-id="element-181">
                "{review.quote}"
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-182">
                <p className="font-bold text-brand-dark" data-id="element-183">{review.author}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}